import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { MessageDescriptorPropType } from '../../../../prop-types/intl';
import HelpArticleLink from '../../../../components/help-article-link';
import { linkIDs } from '../../../../services/link-service/links';
import style from './style.module.less';

const Page = ({ children, messages, rightAlignedComponent = null, sectionLink = '', shouldShowHelperLink = true }) => (
  <div className={style['page-content']}>
    <div className={style['header-bar']}>
      <h1>
        <FormattedMessage {...messages.headerMessage} />
      </h1>
      {shouldShowHelperLink && (
        <div className={style['sub-title-container']}>
          <HelpArticleLink anchor={sectionLink} articleId={linkIDs.InsightsPages} className={style['helper-link']}>
            <FormattedMessage defaultMessage='Learn more' description='link to kb help articles' id='BXHVGu' />
          </HelpArticleLink>
        </div>
      )}
      {rightAlignedComponent}
    </div>
    {children}
  </div>
);

Page.propTypes = {
  children: PropTypes.node.isRequired,
  messages: PropTypes.shape({
    headerMessage: MessageDescriptorPropType,
  }).isRequired,
  rightAlignedComponent: PropTypes.node,
  sectionLink: PropTypes.string,
  shouldShowHelperLink: PropTypes.bool,
};

export default Page;
